export default () => ({
  init() {
    this.store = Alpine.store("data")
  },

  getPricePerPeriod() {
    return this.store.pricing.getPricePerPeriod({
      offer: this.store.values.activeOffer,
      isChance: this.store.values.exitIntent,
    })
  },

  handleDiscountButtonClick() {
    this.store.internalTracker.trackClick({ clickName: "Anchor 1 Clicked" })
    document.getElementById("selectPlanTitle").scrollIntoView({ behavior: "smooth" })
  },
})
